import React from "react";
import Layout from "../components/layouts/Layout";

const TechnologyCorePage = () => {
  const technologies = [
    {
      id: 'qrc',
      title: '量子リザバコンピューティング（QRC）',
      subtitle: 'Quantum Reservoir Computing',
      description: '量子力学の原理を活用した革新的な機械学習アプローチ',
      features: [
        '低消費電力での高速学習',
        '量子もつれを利用した並列処理',
        'ノイズ耐性の向上',
        '複雑な時系列データの解析'
      ],
      applications: [
        '金融市場予測',
        '気象データ解析',
        '音声・画像認識',
        '最適化問題の解決'
      ],
      technicalSpecs: {
        'プロセッサ': '量子ビット数: 50-100 qubits',
        'アルゴリズム': 'リザバコンピューティング + 量子回路',
        '学習速度': '従来比 10-50倍高速',
        '精度': '95%以上（時系列予測）'
      }
    },
    {
      id: 'hamster',
      title: 'カスタムSLM「Hamster」',
      subtitle: 'Specialized Language Model',
      description: '特定ドメインに特化した高性能言語モデル',
      features: [
        'ドメイン特化型アーキテクチャ',
        '効率的なファインチューニング',
        '多言語対応（日英中韓）',
        'プライバシー保護設計'
      ],
      applications: [
        '技術文書の自動生成',
        '専門用語の翻訳',
        'コード生成・レビュー',
        '契約書類の解析'
      ],
      technicalSpecs: {
        'パラメータ数': '7B - 70B parameters',
        'コンテキスト長': '最大 128K tokens',
        '推論速度': '100 tokens/sec',
        'ファインチューニング': '数時間で完了'
      }
    },
    {
      id: 'bim',
      title: 'BIM生成システム',
      subtitle: 'Building Information Modeling Generation',
      description: 'AIによる建築情報モデルの自動生成技術',
      features: [
        '2D図面からの3Dモデル生成',
        '構造解析データの統合',
        '材料コスト自動算出',
        'リアルタイム設計変更反映'
      ],
      applications: [
        '建築設計の効率化',
        '施工計画の最適化',
        'コスト見積もりの自動化',
        '設計変更の影響分析'
      ],
      technicalSpecs: {
        '入力形式': 'DWG, PDF, スキャン画像',
        '出力形式': 'IFC, Revit, SketchUp',
        '生成時間': '平均 15分（中規模建物）',
        '精度': '寸法誤差 ±2%以内'
      }
    }
  ];

  return (
    <Layout 
      title="コア技術詳細" 
      subtitle="DeepTeLLの革新的な3つのコア技術をご紹介します"
    >
      {/* 技術一覧 */}
      <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          {technologies.map((tech, index) => (
            <div key={tech.id} className="row" style={{ marginBottom: index < technologies.length - 1 ? '120px' : '0' }}>
              <div className="col-md-12">
                <div style={{ 
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '16px',
                  padding: '50px',
                  position: 'relative'
                }}>
                  {/* ヘッダー */}
                  <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                    <h2 style={{ color: '#3b82f6', fontSize: '36px', fontWeight: '700', marginBottom: '10px' }}>
                      {tech.title}
                    </h2>
                    <h3 style={{ color: '#94a3b8', fontSize: '18px', fontWeight: '400', marginBottom: '20px' }}>
                      {tech.subtitle}
                    </h3>
                    <p style={{ color: '#cbd5e1', fontSize: '18px', maxWidth: '600px', margin: '0 auto' }}>
                      {tech.description}
                    </p>
                  </div>

                  <div className="row">
                    {/* 主要機能 */}
                    <div className="col-md-4" style={{ marginBottom: '40px' }}>
                      <h4 style={{ color: '#f1f5f9', marginBottom: '20px', fontSize: '20px' }}>
                        主要機能
                      </h4>
                      <ul style={{ listStyle: 'none', padding: 0 }}>
                        {tech.features.map((feature, idx) => (
                          <li key={idx} style={{ 
                            color: '#cbd5e1', 
                            marginBottom: '12px',
                            paddingLeft: '20px',
                            position: 'relative'
                          }}>
                            <span style={{ 
                              position: 'absolute',
                              left: 0,
                              color: '#3b82f6',
                              fontWeight: 'bold'
                            }}>
                              ✓
                            </span>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* 応用分野 */}
                    <div className="col-md-4" style={{ marginBottom: '40px' }}>
                      <h4 style={{ color: '#f1f5f9', marginBottom: '20px', fontSize: '20px' }}>
                        応用分野
                      </h4>
                      <ul style={{ listStyle: 'none', padding: 0 }}>
                        {tech.applications.map((app, idx) => (
                          <li key={idx} style={{ 
                            color: '#cbd5e1', 
                            marginBottom: '12px',
                            paddingLeft: '20px',
                            position: 'relative'
                          }}>
                            <span style={{ 
                              position: 'absolute',
                              left: 0,
                              color: '#10b981',
                              fontWeight: 'bold'
                            }}>
                              →
                            </span>
                            {app}
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* 技術仕様 */}
                    <div className="col-md-4">
                      <h4 style={{ color: '#f1f5f9', marginBottom: '20px', fontSize: '20px' }}>
                        技術仕様
                      </h4>
                      <div>
                        {Object.entries(tech.technicalSpecs).map(([key, value], idx) => (
                          <div key={idx} style={{ 
                            background: 'rgba(59, 130, 246, 0.1)',
                            padding: '12px 16px',
                            borderRadius: '8px',
                            marginBottom: '10px'
                          }}>
                            <div style={{ color: '#3b82f6', fontSize: '14px', fontWeight: '600' }}>
                              {key}
                            </div>
                            <div style={{ color: '#cbd5e1', fontSize: '13px' }}>
                              {value}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* アクションボタン */}
                  <div style={{ textAlign: 'center', marginTop: '40px' }}>
                    <a 
                      href={`/contact/demo?tech=${tech.id}`}
                      className="btn btn-custom"
                      style={{ marginRight: '15px' }}
                    >
                      デモを申し込む
                    </a>
                    <a 
                      href={`/resources/technical-docs?tech=${tech.id}`}
                      className="btn btn-outline"
                      style={{ 
                        border: '1px solid rgba(59, 130, 246, 0.5)',
                        color: '#3b82f6',
                        background: 'transparent'
                      }}
                    >
                      技術資料をダウンロード
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 比較表 */}
      <section style={{ padding: '80px 0', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 style={{ 
                color: '#f1f5f9', 
                textAlign: 'center', 
                marginBottom: '50px',
                fontSize: '32px',
                fontWeight: '700'
              }}>
                技術比較表
              </h2>
              <div style={{ 
                background: 'rgba(30, 41, 59, 0.8)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                borderRadius: '12px',
                overflow: 'hidden'
              }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: 'rgba(59, 130, 246, 0.1)' }}>
                      <th style={{ padding: '20px', color: '#f1f5f9', textAlign: 'left' }}>技術</th>
                      <th style={{ padding: '20px', color: '#f1f5f9', textAlign: 'center' }}>処理速度</th>
                      <th style={{ padding: '20px', color: '#f1f5f9', textAlign: 'center' }}>精度</th>
                      <th style={{ padding: '20px', color: '#f1f5f9', textAlign: 'center' }}>適用範囲</th>
                      <th style={{ padding: '20px', color: '#f1f5f9', textAlign: 'center' }}>独自性</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ borderBottom: '1px solid rgba(59, 130, 246, 0.1)' }}>
                      <td style={{ padding: '20px', color: '#cbd5e1', fontWeight: '600' }}>QRC</td>
                      <td style={{ padding: '20px', color: '#10b981', textAlign: 'center' }}>★★★★★</td>
                      <td style={{ padding: '20px', color: '#10b981', textAlign: 'center' }}>★★★★★</td>
                      <td style={{ padding: '20px', color: '#f59e0b', textAlign: 'center' }}>★★★</td>
                      <td style={{ padding: '20px', color: '#10b981', textAlign: 'center' }}>★★★★★</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid rgba(59, 130, 246, 0.1)' }}>
                      <td style={{ padding: '20px', color: '#cbd5e1', fontWeight: '600' }}>Hamster</td>
                      <td style={{ padding: '20px', color: '#10b981', textAlign: 'center' }}>★★★★</td>
                      <td style={{ padding: '20px', color: '#10b981', textAlign: 'center' }}>★★★★</td>
                      <td style={{ padding: '20px', color: '#10b981', textAlign: 'center' }}>★★★★★</td>
                      <td style={{ padding: '20px', color: '#10b981', textAlign: 'center' }}>★★★★</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '20px', color: '#cbd5e1', fontWeight: '600' }}>BIM生成</td>
                      <td style={{ padding: '20px', color: '#10b981', textAlign: 'center' }}>★★★★</td>
                      <td style={{ padding: '20px', color: '#10b981', textAlign: 'center' }}>★★★★★</td>
                      <td style={{ padding: '20px', color: '#f59e0b', textAlign: 'center' }}>★★★</td>
                      <td style={{ padding: '20px', color: '#10b981', textAlign: 'center' }}>★★★★★</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ 
        padding: '80px 0',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px', fontSize: '32px' }}>
                技術の詳細をさらに詳しく
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                各技術の具体的な仕様や導入事例について<br />
                詳しい資料をご提供いたします
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                <a href="/contact/demo" className="btn btn-custom btn-lg" style={{ 
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '2px solid white',
                  color: 'white'
                }}>
                  技術デモを申し込む
                </a>
                <a href="/resources/technical-docs" className="btn btn-custom btn-lg" style={{ 
                  background: 'white',
                  color: '#1e40af',
                  border: '2px solid white'
                }}>
                  技術資料をダウンロード
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TechnologyCorePage; 